"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NextgenSubscriptionStatus = exports.NextgenSubscriptionTerm = exports.NextgenSubscriptionPartner = exports.NextgenSubscriptionPlanType = exports.NextgenSubscriptionErrorType = exports.NextgenSubscriptionUnit = void 0;
var NextgenSubscriptionUnit;
(function (NextgenSubscriptionUnit) {
    NextgenSubscriptionUnit["Month"] = "Month";
})(NextgenSubscriptionUnit = exports.NextgenSubscriptionUnit || (exports.NextgenSubscriptionUnit = {}));
var NextgenSubscriptionErrorType;
(function (NextgenSubscriptionErrorType) {
    NextgenSubscriptionErrorType["PaymentMethodRequired"] = "PaymentMethodRequired";
})(NextgenSubscriptionErrorType = exports.NextgenSubscriptionErrorType || (exports.NextgenSubscriptionErrorType = {}));
var NextgenSubscriptionPlanType;
(function (NextgenSubscriptionPlanType) {
    NextgenSubscriptionPlanType["Base"] = "Base";
    NextgenSubscriptionPlanType["Benefits"] = "Benefits";
    NextgenSubscriptionPlanType["Corporate"] = "Corporate";
    NextgenSubscriptionPlanType["Service"] = "Service";
})(NextgenSubscriptionPlanType = exports.NextgenSubscriptionPlanType || (exports.NextgenSubscriptionPlanType = {}));
;
var NextgenSubscriptionPartner;
(function (NextgenSubscriptionPartner) {
    NextgenSubscriptionPartner["USA"] = "USA";
})(NextgenSubscriptionPartner = exports.NextgenSubscriptionPartner || (exports.NextgenSubscriptionPartner = {}));
;
var NextgenSubscriptionTerm;
(function (NextgenSubscriptionTerm) {
    NextgenSubscriptionTerm["Yearly"] = "Yearly";
    NextgenSubscriptionTerm["Monthly"] = "Monthly";
})(NextgenSubscriptionTerm = exports.NextgenSubscriptionTerm || (exports.NextgenSubscriptionTerm = {}));
;
var NextgenSubscriptionStatus;
(function (NextgenSubscriptionStatus) {
    NextgenSubscriptionStatus["Active"] = "Active";
    NextgenSubscriptionStatus["Canceled"] = "Canceled";
})(NextgenSubscriptionStatus = exports.NextgenSubscriptionStatus || (exports.NextgenSubscriptionStatus = {}));
;
;
;
;
;
;
//# sourceMappingURL=nextgenSubscription.js.map